import { useQuery } from "@tanstack/vue-query";
import educationLevelsService from "@/services/educationLevels.js";

export const useGetEducationLevelsData = (limit, page, q) => {
  return useQuery({
    queryKey: ["fetchEducationLevelsData", limit, page, q],
    queryFn: () =>
      educationLevelsService.getEducationLevels(limit, page, q.value ?? "").then((val) => val?.data?.data?.items),
    staleTime: 0,
  });
};
